import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { DisplayEuroMUI } from 'src/utils/formats';

// import schemas
import { EMOB_LIS_STANDORTE_PATHS } from 'src/lib/constants/componentsPath';
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const InvestitionsUebersichtAntragEmobLIS: FC<{}> = () => {
	const { application } = useApplication();
	const columns = [
		// { field: 'id', headerName: 'ID', width: 80, groupable: false },
		{ field: 'bezeichnung', headerName: 'Standort Bezeichnung', flex: 1, groupable: false, width: 200 },
		{ field: 'kostenKategorie', headerName: 'Kostenkategorie', flex: 1, groupable: false },
		...Array.from({ length: get(application, P.Allgemein_Projektdauerin_Jahren.path) }).map((_, i) => {
			return {
				field: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
				headerName: `Ausgaben im Projektjahr ${i + 1} [€]`,
				flex: 1,
				type: 'number' as const,
				valueFormatter: (value: any) => {
					return value ? DisplayEuroMUI(value) : 0;
				},
			};
		}),
		{
			field: 'gesamtSumme',
			headerName: 'Geplante Gesamtsumme [€]',
			width: 250,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : 0;
			},
		},
	];

	const getStandortName = (standortGroupId: string) => {
		const alleStandorte_arr = get(
			application,
			P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.path,
			[]
		);
		const selectedStandort = alleStandorte_arr.find((ele: any) => get(ele, EMOB_LIS_STANDORTE_PATHS.GroupId, '') === standortGroupId);
		const standOrtName =
			get(selectedStandort, EMOB_LIS_STANDORTE_PATHS.StasseUndHausnummer, '') ?
				`${get(selectedStandort, EMOB_LIS_STANDORTE_PATHS.StasseUndHausnummer, '')}`
			:	'';
		return standOrtName;
	};

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === 'Investitionskosten')
			.map((ele: any) => {
				const kostenProJahr = get(ele, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).reduce((acc: any, proJahr: any) => {
					acc[get(proJahr, 'Zelle_1')] = get(proJahr, 'Zelle_2');
					return acc;
				}, {});

				const standOrtGroupID = get(ele, KP_P.Allgemein_Standort_Group_ID.path, '');
				return {
					id: get(ele, 'id'),
					bezeichnung: getStandortName(standOrtGroupID),
					kostenart: get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path),
					kostenKategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
					...kostenProJahr,
					gesamtSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return row;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [application]);

	const initialState: any = useMemo(() => {
		const projectStartYear = get(application, P.Allgemein_Projektstart_Jahr.path);
		const projectDurationYears = get(application, P.Allgemein_Projektdauerin_Jahren.path);

		const model: any = Array.from({ length: projectDurationYears }).reduce((acc: any, _, i) => {
			acc[projectStartYear + i] = 'sum';
			return acc;
		}, {});

		return {
			aggregation: {
				model: {
					...model,
					gesamtSumme: 'sum',
				},
			},
			columns: {
				columnVisibilityModel: {
					// Hide the column used for leaves
					bezeichnung: false,
				},
			},
			rowGrouping: {
				model: ['bezeichnung'],
			},
		};
	}, [application]);

	return (
		<>
			<ApplicationHeading title='Investitionkosten Übersicht' description={PLATZHALTER_TEXT} />
			<div style={{ height: 400, width: '100%' }}>
				<DataGridPremium
					autoHeight
					rows={rows}
					columns={columns}
					initialState={initialState}
					groupingColDef={{ leafField: 'unternehmen', hideDescendantCount: true }}
					hideFooter
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
				/>
			</div>
		</>
	);
};
export default InvestitionsUebersichtAntragEmobLIS;
